import { VulnerableProjectModel } from '@models';

export interface RootVulnerableProjectsResult {
  rootVulnerableProjects: VulnerableProjectModel[];
}
